import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeUnmount } from "vue";
import { DIGIT_ONLY_REGEX } from "@/utils/constants";
import { AxiosError } from "axios";
import AccountActivationRepository from "@/utils/API/AccountActivationRepository";
import {useTranslations} from "@/hooks/useTranslations";


export default /*#__PURE__*/_defineComponent({
  __name: 'DirectSignUpVerificationForm',
  props: {
  userEmail: { type: String, required: true },
},
  emits: ["verifiedSuccess", "verificationFailed"],
  setup(__props, { emit }) {

const props = __props;





const translations = useTranslations();
const verificationCharacters = ref(Array(6).fill(""));
const verificationCode = ref("");
const verificationError = ref("");
const isVerifying = ref(false);
const isResendDisabled = ref(false);
const resendCountdown = ref(0);
let resendTimer: number | null = null;

// Display email
const displayedEmail = props.userEmail;

// ✅ Combine characters into final code
function updateCode() {
  verificationCode.value = verificationCharacters.value.join("");
}

function handleInputChange(index: number, event: Event) {
  const input = event.target as HTMLInputElement;
  const value = input.value;

  if (DIGIT_ONLY_REGEX.test(value)) {
    verificationCharacters.value[index] = value;

    if (value && index < 5) {
      const next = input.nextElementSibling as HTMLInputElement;
      next.focus();
    }

    updateCode();
  }
  else {
    verificationCharacters.value[index] = "";
  }
}

function handleBackspace(index: number) {
  if (!verificationCharacters.value[index] && index > 0) {
    const prev = document.querySelectorAll(".code-input")[index - 1] as HTMLInputElement;
    prev.focus();
  }
  updateCode();
}

async function handleSubmit() {
  if (!verificationCode.value) {
    verificationError.value = translations.value.get("verification_code_invalid");
    return;
  }

  try {
    isVerifying.value = true;
    verificationError.value = "";

    await AccountActivationRepository.verifyAccountActivationStatus(verificationCode.value);
    await AccountActivationRepository.verifyEmail(verificationCode.value);

    emit("verifiedSuccess");
  }

  catch (error) {
    let msg = "Verification failed.";
    const axiosError = error as AxiosError;
    if (axiosError.response.data.message) msg = axiosError.response.data.message;

    verificationError.value = msg;
    emit("verificationFailed", msg);
  }

  finally {
    isVerifying.value = false;
  }
}

function handleResend() {
  if (isResendDisabled.value) return;

  isResendDisabled.value = true;
  resendCountdown.value = 60;

  resendTimer = window.setInterval(() => {
    resendCountdown.value--;
    if (resendCountdown.value <= 0) {
      isResendDisabled.value = false;
      clearInterval(resendTimer!);
      resendTimer = null;
    }
  }, 1000);

  AccountActivationRepository.resendVerificationCode(displayedEmail)
    .catch(() => {
      verificationError.value = translations.value.get("verification_code_request_failed");
      isResendDisabled.value = false;
      clearInterval(resendTimer!);
      resendTimer = null;
    });
}

onBeforeUnmount(() => {
  if (resendTimer) clearInterval(resendTimer);
});

return { __sfc: true,props, emit, translations, verificationCharacters, verificationCode, verificationError, isVerifying, isResendDisabled, resendCountdown, resendTimer, displayedEmail, updateCode, handleInputChange, handleBackspace, handleSubmit, handleResend }
}

})